/**
 * Matches `Perpage.vue` default "All entries" option `value` (lazy-fetch chunk size).
 * Prefer comparing `option.value` over translated labels for locale-safe behavior.
 */
export const ALL_ENTRIES_CHUNK_PER_PAGE = 75

export function isAllEntriesPerPageOption(option) {
  return Number(option?.value) === ALL_ENTRIES_CHUNK_PER_PAGE
}
